import styled from 'styled-components';
import { fontStyle, flexPosition } from '../../../styles/mixins';
import {
  FONT_SIZE_6,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_NORMAL,
  GRAY_MEDIUM,
  GRAY_DARKER_2,
  GRAY_LIGHTER,
  FONT_SIZE_5,
} from '../../../styles/variables';

export const MenuResume = styled.div``;

export const Title = styled.h2`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
  margin: 0;
  ${props => props.style}
`;

export const MarketplacesName = styled.h3`
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin-bottom: 5px;
  text-transform: capitalize;
`;

export const MenuType = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_6, FONT_WEIGHT_NORMAL)}
  margin: 0;
`;

export const LineSeparator = styled.div`
  margin: 30px auto;
  width: 100%;
  border-bottom: 2px solid ${GRAY_DARKER_2};
`;

export const HelperMarketplaces = styled.div`
  width: 100%;
  height: 240px;
  ${flexPosition({ align: 'top', justify: 'space-between' })}
  ${props =>
    props.hoverMktpcStyle
      ? `
    flex-direction: column;
    ${flexPosition({ align: 'top', justify: 'flex-start' })}
    padding-left: 10px;
  `
      : null}
`;

export const TagMktpcContainer = styled.div`
  width: ${props => (props.hoverMktpcStyle ? '100%' : '40%')};
  position: relative;
`;

export const MenuWith = styled.h2`
  margin-top: 5px;
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
`;

export const HoverMktpc = styled.span`
  color: #fff;
  text-transform: capitalize;
`;

export const Tag = styled.span`
  width: 100px;
  height: 25px;
  border-radius: 15px;
  background-color: ${GRAY_LIGHTER};
  display: flex;
`;

export const LineHelper = styled.span`
  position: absolute;
  border-left: 2px solid #979797;
  height: 120px;
  left: ${props => (props.hoverMktpcStyle ? '-30px' : '-20px')};
  top: 13px;
  &::before {
    content: '';
    width: 18px;
    border-top: 2px solid #979797;
    display: block;
  }
  &::after {
    content: '';
    width: 24px;
    border-top: 2px solid #979797;
    bottom: 0;
    left: -26px;
    display: block;
    position: absolute;
  }
`;

export const InfoHelper = styled.div`
  width: 60%;
`;

export const HelpTitle = styled.h1`
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin-top: 0;
`;

export const HelpDesc = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
`;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/MenuResumeHelper/style.js